import { Trans } from '@lingui/macro';
import React from 'react';

const ToolTipScenarioPerformance = ({ item }) => {
  const { x, y, name } = item;
  return (
    <div style={{ fontSize: 13, padding: 5 }}>
      <div>{name}</div>
      <div>
        <Trans>Hiển thị:</Trans>&nbsp;{x}
      </div>
      <div>
        <Trans>Tương tác:</Trans>&nbsp;{y}
      </div>
    </div>
  );
};

export default ToolTipScenarioPerformance;
